import { Link } from "react-router-dom";
import styled from "styled-components";

export const NavContainer = styled.nav`
  background-color: white;
  padding: 4px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 1000;
  font-family: "Pretendard", sans-serif;
  max-width: 2560px;
  margin: 0 auto;
  width: 100%;
  height: 52px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (min-width: 2560px) {
    width: 2560px;
  }

  @media (max-width: 768px) {
    height: 48px;
  }
`;

export const NavList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  gap: 20px;

  @media (max-width: 1920px) {
    gap: 18px;
  }

  @media (max-width: 1440px) {
    gap: 16px;
  }

  @media (max-width: 1024px) {
    gap: 14px;
  }

  @media (max-width: 768px) {
    gap: 12px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const NavItem = styled.li`
  margin: 0 15px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
`;

export const NavLink = styled(Link)`
  color: black;
  font-style: normal;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px; /* 155.556% */
  font-feature-settings: "liga" off, "clig" off;
  text-decoration: none;
  font-family: Pretendard;
  padding: 10px 20px;
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 8px;

  transition: background-color 0.3s, color 0.3s;
  text-align: center;

  &:hover {
    background-color: #000000;
    color: #ffffff;
    border-radius: 8px;
    border: 0px solid transparent;
  }
`;

export const PrivacyLink = styled.button`
  color: black;
  font-style: normal;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px; /* 155.556% */
  font-feature-settings: "liga" off, "clig" off;
  text-decoration: none;
  font-family: Pretendard;
  padding: 10px 20px;
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s, color 0.3s;
  text-align: center;

  &:hover {
    background-color: #000000;
    color: #ffffff;
    border-radius: 8px;
    border: 0px solid transparent;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const AdminLink = styled.button`
  color: black;
  font-style: normal;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px; /* 155.556% */
  font-feature-settings: "liga" off, "clig" off;
  text-decoration: none;
  font-family: Pretendard;
  padding: 10px 20px;
  display: inline-block;
  vertical-align: middle;
  margin: 0 10px;
  background: rgb(0, 28, 242);
  color: rgb(255, 255, 255);
  border: none;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s, color 0.3s;
  text-align: center;

  &:hover {
    background-color: #000000;
    color: rgb(255, 255, 255);
    border-radius: 8px;
    border: 0px solid transparent;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const HomeLink = styled(NavLink)`
  font-size: 28px;
  font-weight: 800;
  padding: 10px;
  margin: 0 15px;
`;

export const ButtonItem = styled.li`
  margin: 0 40px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const UserButton = styled.button`
  font-family: Pretendard;
  width: 96px;
  height: 48px;
  font-size: 14px;
  font-weight: 400;
  border: 0px solid transparent;
  border-radius: 8px;
  background-color: #fff;
  color: #000000;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  margin: 0 10px;

  &:hover {
    font-size: 16px;
    font-weight: 700;
    background-color: #000000;
    color: #ffffff;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const HamburgerMenuButton = styled.div`
  display: none;
  cursor: pointer;
  @media (max-width: 768px) {
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 20px;
    flex-shrink: 0;
    background: none;
    border: none;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 480px) {
    width: 24px;
    height: 24px;
    margin-right: 20px;
    flex-shrink: 0;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  flex-wrap: nowrap;

  @media (max-width: 1920px) {
    gap: 9px;
    margin-top: 18px;
  }

  @media (max-width: 1440px) {
    gap: 8px;
    margin-top: 16px;
  }

  @media (max-width: 1024px) {
    gap: 7px;
    margin-top: 14px;
  }

  @media (max-width: 768px) {
    gap: 6px;
    margin-top: 12px;
    width: 100%;
  }

  @media (max-width: 480px) {
    gap: 5px;
    margin-top: 10px;
  }
`;
